import React, { useState } from 'react';
import { X } from 'lucide-react';
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import './navbar.scss';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false); // close menu after clicking a link
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar__logo">
        <Link to="/">
          <img
            src="https://res.cloudinary.com/dsnontai6/image/upload/v1758991862/Orter/Colored_2_Transparent_xsfkyj.png"
            alt="Orter Logo"
            className="navbar__logo-image"
          />
        </Link>
      </div>

      {/* Desktop menu */}
      <div className="navbar__menu">
        <Link to="/" className="navbar__button">Home</Link>
        {/* <Link to='/features' className="navbar__button">Features</Link> */}
        <Link to='/contact-us' className="navbar__button">Contact Us</Link>
        <Link to="/download" className="navbar__download-btn">Download the App</Link>
      </div>

      {/* Mobile toggle icon */}
      <div className="navbar__mobile-menu" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <X className="navbar__menu-icon" /> : <HiOutlineMenuAlt2 className="navbar__menu-icon" />}
      </div>

      {/* Mobile dropdown menu */}
      {isOpen && (
        <div className="navbar__dropdown">
          <Link to="/" className="navbar__dropdown-link">Home</Link>
          {/* <Link to="/features" className="navbar__dropdown-link">Features</Link> */}
          <Link to="/contact-us" className="navbar__dropdown-link">Contact Us</Link>
          <Link to="/download" className="navbar__dropdown-btn">Download the App</Link>
        </div>
      )}
    </nav>
  );
}
